import Vue from 'vue';
import Router from 'vue-router';
import { AuthGuard } from '@/utils';
import qs from 'qs';
import { Http } from '../../../utils/http/http';
import AppCenterService from "@service/app/app-center-service";
import axios from 'axios'

Vue.use(Router);

export const parentRoutes: any = [
    {
    path: '/appindexview/:appindexview?',
    name: 'appindexview',
    beforeEnter: (to: any, from: any, next: any) => {
        const routerParamsName = 'appindexview';
        const params: any = {};
        if (to.params && to.params[routerParamsName]) {
            Object.assign(params, qs.parse(to.params[routerParamsName], { delimiter: ';' }));
        }
        const url: string = '/runtimeapi/appdataAll';
        const auth: Promise<any> = AuthGuard.getInstance().authGuard(url, params, router);
        auth.then(() => {
            next();


        // 判断是否是第一次登录，第一次登录弹出修改密码弹窗
        Http.getInstance().get('/runtimeapi/validUserPWDStatus').then(res => {
            if (res.data){
                AppCenterService.notifyMessage({name:"isFirstLogin",action:'changepassword',data:{'canClose': false, "modalVisible": true}})
            }
        })
        }).catch(() => {
            next();
        });
    },
    meta: {
        caption: 'app.views.appindexview.caption',
        info:'',
        viewType: 'APPINDEX',
        parameters: [
            { pathName: 'appindexview', parameterName: 'appindexview' },
        ],
        requireAuth: true,
    },
    component: () => import('@pages/wkd/app-index-view/app-index-view.vue'),
    children: [
        {
            path: 'notice-table',
            meta: {
                caption: '公告通知'
            },
            component: () => import('@pages/wkd/notice/index.vue')
        },
        {
            path: 'message-table',
            meta: {
                caption: '消息预警'
            },
            component: () => import('@pages/wkd/message/index.vue')
        },
        {
            path: 'todoTask',
            meta: {
                caption: '待审批流程'
            },
            component: () => import('@pages/wkd/task/todoTask.vue')
        },
        {
            path: 'complatedTask',
            meta: {
                caption: '已完成的流程'
            },
            component: () => import('@pages/wkd/task/complatedTask.vue')
        },
        {
            path: 'startedTask',
            meta: {
                caption: '我启动的流程'
            },
            component: () => import('@pages/wkd/task/startedTask.vue')
        },
        {
            path: 'monitor',
            meta: {
                caption: '监测'
            },
            component: () => import('@pages/wkd/monitor/index.vue')
        },
    ]
}]
export const constantRoutes: any = [
    {
        path: '/login/:login?',
        name: 'login',
        meta: {
            caption: '登录',
            viewType: 'login',
            requireAuth: false,
            ignoreAddPage: true,
        },
        beforeEnter: (to: any, from: any, next: any) => {
            router.app.$store.commit('resetRootStateData');
            next();
        },
        component: () => import('@components/login/login.vue'),
    },
    {
        path: '/sso/:sso?',
        name: 'sso',
        meta: {
            caption: 'sso',
            viewType: 'sso',
            requireAuth: false,
            ignoreAddPage: true,
        },
        beforeEnter: (to: any, from: any, next: any) => {
            // Util.checkSso(this.$route,this.$http);
            next()
        },
        component: () => import('@components/login/sso.vue'),
    },
    {
        path: '/lock',
        name: 'lock',
        meta: {
            caption: '锁屏',
            viewType: 'lock',
            requireAuth: false,
            ignoreAddPage: true,
        },
        beforeEnter: (to: any, from: any, next: any) => {
            next();
        },
        component: () => import('@components/app-lock/app-lock.vue'),
    },
    {
        path: '/404',
        component: () => import('@components/404/404.vue')
    },
    {
        path: '/500',
        component: () => import('@components/500/500.vue')
    },
    {
        path: '*',
        redirect: 'appindexview'
    },
]

const router = new Router({
    routes: [
        ...parentRoutes,
        ...constantRoutes
    ],
});

// 解决路由跳转路由重复时报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location: any) {
    let result: any = originalPush.call(this, location);
    return result.catch((err: any) => err);
}
export default router;
